// ============================================================
// Pay Rocky - Public Navbar
// ============================================================

import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/Primitives';

const NAV_LINKS = [
  { label: 'Buy Crypto', to: '/buy' },
  { label: 'Sell Crypto', to: '/sell' },
  { label: 'Live Rates', to: '/rates' },
  { label: 'FAQ', to: '/faq' },
];

export default function Navbar() {
  const { currentUser, logout, isAdmin } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        borderBottom: '1px solid var(--clr-border)',
        background: 'rgba(255, 250, 245, 0.92)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1.5rem',
          height: '68px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              background: 'linear-gradient(135deg, var(--clr-accent) 0%, var(--clr-accent-2) 100%)',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'var(--font-display)',
              fontWeight: 800,
              fontSize: '14px',
              color: 'var(--clr-on-accent)',
              boxShadow: '0 10px 24px rgba(143, 59, 46, 0.22)',
            }}
          >
            P
          </div>
          <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '17px', letterSpacing: '-0.02em', color: 'var(--clr-text)' }}>
            Pay<span style={{ color: 'var(--clr-accent)' }}>Rocky</span>
          </span>
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }} className="desktop-nav">
          {NAV_LINKS.map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              style={{
                padding: '8px 14px',
                borderRadius: 'var(--radius-sm)',
                fontSize: '13px',
                fontWeight: 600,
                color: isActive(to) ? 'var(--clr-accent)' : 'var(--clr-text-2)',
                background: isActive(to) ? 'var(--clr-accent-dim)' : 'transparent',
                transition: 'all 0.15s',
              }}
            >
              {label}
            </Link>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {currentUser ? (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate(isAdmin ? '/admin' : '/dashboard')}>
                Dashboard
              </Button>
              <Button variant="danger" size="sm" onClick={handleLogout}>
                Sign out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate('/login')}>
                Sign in
              </Button>
              <Button variant="primary" size="sm" onClick={() => navigate('/signup')}>
                Get started
              </Button>
            </>
          )}

          <button
            onClick={() => setOpen(!open)}
            style={{ display: 'none', color: 'var(--clr-text)', padding: '4px' }}
            className="mobile-menu-btn"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          style={{
            padding: '1rem 1.5rem 1.25rem',
            borderTop: '1px solid var(--clr-border)',
            background: 'rgba(255, 255, 255, 0.95)',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          {NAV_LINKS.map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              style={{
                padding: '10px 14px',
                borderRadius: 'var(--radius-md)',
                fontSize: '14px',
                color: isActive(to) ? 'var(--clr-accent)' : 'var(--clr-text)',
                background: isActive(to) ? 'var(--clr-accent-dim)' : 'transparent',
              }}
            >
              {label}
            </Link>
          ))}
          {!currentUser && (
            <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
              <Button variant="ghost" size="sm" fullWidth onClick={() => { navigate('/login'); setOpen(false); }}>
                Sign in
              </Button>
              <Button variant="primary" size="sm" fullWidth onClick={() => { navigate('/signup'); setOpen(false); }}>
                Get started
              </Button>
            </div>
          )}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </nav>
  );
}
